// withPermission.tsx
import React from 'react';
import { PagePermission } from '../../services/usePermission';
import Unauthorised from './Unauthorised';
 
type PermissionProps = {
  moduleCode: string;
  pageCode:string;
  children: React.ReactNode;
};
 
export const PagePermissionRedirect: React.FC<PermissionProps> = ({ moduleCode,pageCode, children }) => {
  const hasPermission = PagePermission(moduleCode,pageCode);
  // Render the children if the user has the required permission, else render nothing
  return <>{hasPermission ? children : <Unauthorised />}</>;
};